import type { HomeScope } from '@UI/Pages/Home/Signals/homeScopeSignal';

/** Primitive identity of a scope, used as the option value of the scope dropdown. */
const buildHomeScopeKey = (scope: HomeScope): string => {
	return scope.kind === 'all' ? 'all' : `${scope.kind}:${scope.id}`;
};

export default buildHomeScopeKey;
